import actions from './moduleClassificationActions';
import mutations from './moduleClassificationMutations';
import getters from './moduleClassificationGetters';
import state from './moduleClassificationState';

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
